import type { ReactNode } from "react";

/**
 * Tekst ze schematu z prostym formatowaniem: `**pogrubienie**`, akapity
 * i listy („1. …", „- …"). Noty końcowe mówią, co kandydat ma teraz zrobić,
 * a instrukcja w jednym ciągu z gwiazdkami i numerami w środku zdania jest
 * nie do przeczytania na telefonie.
 *
 * Składamy wyłącznie elementy Reacta, bez HTML-a: treść schematu nie może
 * wstrzyknąć na stronę niczego poza tekstem.
 */

/** `**tekst**` → <strong>; reszta zostaje zwykłym tekstem. */
export function pogrubienie(tekst: string): ReactNode[] {
  return tekst.split(/(\*\*[^*]+\*\*)/g).map((czesc, i) =>
    czesc.startsWith("**") && czesc.endsWith("**") && czesc.length > 4 ? (
      <strong key={i}>{czesc.slice(2, -2)}</strong>
    ) : (
      czesc
    ),
  );
}

const NUMEROWANA = /^\s*\d+[.)]\s+/;
const PUNKTOWANA = /^\s*[-•]\s+/;

function wiersze(tekst: string): ReactNode[] {
  return tekst.split("\n").flatMap((wiersz, i) => (i === 0 ? pogrubienie(wiersz) : [<br key={`br${i}`} />, ...pogrubienie(wiersz)]));
}

function Blok({ tekst }: { tekst: string }) {
  const linie = tekst.split("\n").map((l) => l.trim()).filter(Boolean);
  if (linie.length && linie.every((l) => NUMEROWANA.test(l))) {
    return <ol>{linie.map((l, i) => <li key={i}>{pogrubienie(l.replace(NUMEROWANA, ""))}</li>)}</ol>;
  }
  if (linie.length && linie.every((l) => PUNKTOWANA.test(l))) {
    return <ul>{linie.map((l, i) => <li key={i}>{pogrubienie(l.replace(PUNKTOWANA, ""))}</li>)}</ul>;
  }
  return <p>{wiersze(linie.join("\n"))}</p>;
}

export function TekstSchematu({ tekst, className }: { tekst: string; className?: string }) {
  const bloki = tekst.split(/\n\s*\n/).filter((b) => b.trim());
  const zlozony = bloki.length > 1 || /^\s*(\d+[.)]|[-•])\s+/m.test(tekst);
  return (
    <div className={`tekst-schematu${zlozony ? " tekst-schematu--zlozony" : ""}${className ? ` ${className}` : ""}`}>
      {bloki.map((blok, i) => <Blok key={i} tekst={blok} />)}
    </div>
  );
}
